import React from 'react';
import { FormGroup, Input } from '@tencent/spaui';

const MyInput = (props) => {
  const { value = '', disabled = false, valid = true, calculateLength } = props;

  let maxLength = 0;
  if (props.maxLen != undefined) {
    maxLength = props.maxLen;
  } else if (props.maxLength != undefined) {
    maxLength = props.maxLength;
  }

  let valueLength;
  if (calculateLength && typeof calculateLength === 'function') {
    valueLength = calculateLength(value);
  } else {
    valueLength = value.length;
  }

  let status = props.status || 'normal';

  if (!valid) {
    status = 'error';
  }

  return (
    <FormGroup
      status={status}
      feedback={
        <span>
          <span className="spaui-input-feedback-count">{valueLength}</span>
          <span className="spaui-input-feedback-divider">/</span>
          <span className="spaui-input-feedback-range">{maxLength}</span>
        </span>
      }
    >
      <Input truncate={props.truncate} {...props} disabled={disabled} />
    </FormGroup>
  );
};

export default MyInput;
